import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ServiceChannelOAuth } from '../modules/ServiceChannelOAuth';

export const Route = createFileRoute('/servicechannel-oauth')({
  component: RouteComponent,
  head: () => {
    return {
      meta: [{ title: 'ServiceChannel OAuth' }],
    };
  },
  validateSearch: z.object({
    code: z.string().optional(),
    state: z.coerce.string().optional(),
  }),
});

function RouteComponent() {
  return <ServiceChannelOAuth />;
}
